import { FAQ_HEADING, faqItems, sectionLabel } from './homepageContent';

/**
 * FAQ — before the closing call to action, answering what stops an advocate starting a
 * trial. Native <details>/<summary>: keyboard-operable with no script, readable with
 * JavaScript-driven animation off, and announced as expandable by screen readers. Answers
 * that depend on a publication gate are left out until it is on (homepageContent faqItems).
 * The questions run the page's full width, like every band above them; only the answers
 * keep a reading measure. It follows the pricing band on the same parchment, so a brass rule
 * marks where one ends (as on the searches band).
 */
export default function FaqSection() {
  return (
    <section
      id="faq"
      aria-labelledby="faq-heading"
      className="scroll-mt-16 border-t border-brass-border bg-parchment px-5 sm:px-8 lg:px-14 py-16 sm:py-20"
    >
      <div className="flex flex-wrap items-baseline justify-between gap-4">
        <h2 id="faq-heading" className="font-display font-normal text-3xl lg:text-[44px] text-chamber-panel">
          {FAQ_HEADING}
        </h2>
        <span className="font-plex text-[11px] tracking-[0.3em] text-brass-deep">{sectionLabel('faq')}</span>
      </div>

      <div className="mt-10 border-t border-parchment-border-strong">
        {faqItems().map((item) => (
          <details key={item.q} className="group border-b border-parchment-border-strong">
            <summary className="flex cursor-pointer list-none items-baseline justify-between gap-6 py-5 font-display text-[19px] sm:text-[21px] text-chamber-panel marker:content-none [&::-webkit-details-marker]:hidden focus-visible:outline focus-visible:outline-2 focus-visible:outline-brass-ink focus-visible:outline-offset-2">
              {item.q}
              <span aria-hidden="true" className="font-plex text-[18px] text-brass-ink transition-transform group-open:rotate-45">
                +
              </span>
            </summary>
            <p className="pb-6 pr-10 text-[15px] leading-[1.7] text-parchment-muted max-w-[760px]">{item.a}</p>
          </details>
        ))}
      </div>
    </section>
  );
}
